import React, { Component } from 'react';
import Loader from 'react-loader-spinner';

export default class DefaultLoader extends Component {
   render() {
      return (
         <div style={{textAlign: 'center'}}>
            <Loader
               type="Puff"
               color="#00BFFF"
               height={150}
               width={150}
            />
         </div>
      );
   }
}